var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AsiToolbar',{attrs:{"icon":_vm.icons.bill,"title":_vm.$t('uiTerms.unpaidBills')}}),_c('BillList',{attrs:{"hide-toolbar":true,"company":_vm.usersCompany,"bill-filter-model":_vm.billFilterModel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }